{
	"accountsPayable": "Accounts payable",
	"accountsReceivable": "Accounts receivable",
	"providers": "Partners Management",
	"costCenter": "Cost center",
	"planAccounts": "Plan of accounts",
	"checkingAccounts": "Checking Accounts",
	"reports": "Reports",
	"cashflow": "Cash flow",
	"finExManagerialReport": "DRE",
	"bankAccounts": "Bank accounts",
	"noticeIsFreeModule": "Free module up to",
	"conciliation": "Conciliation via OFX",
	"eventConference": "Event Conference"
}
